// Runtime config bound to Vite env vars (VITE_*) with defaults from
// .env.development. Failing fast on missing required values is intentional —
// a missing KC authority is a deployment misconfiguration, not a soft warning.

const requireEnv = (key: string, fallback?: string): string => {
  const value = import.meta.env[key] as string | undefined;
  if (value && value.length > 0) return value;
  if (fallback !== undefined) return fallback;
  throw new Error(`Missing required env var: ${key}`);
};

export const KC_AUTHORITY = requireEnv(
  'VITE_KC_AUTHORITY',
  'http://localhost:8081/realms/potato-rocket',
);

export const KC_CLIENT_ID = requireEnv('VITE_KC_CLIENT_ID', 'potato-rocket-web');

// Audience the api enforces. Kept as a separate constant from CLIENT_ID
// because the two need not always be identical (Keycloak audience mappers
// can re-target).
export const KC_AUDIENCE = requireEnv('VITE_KC_AUDIENCE', 'potato-rocket-web');

// App version shown in the sidebar footer (DESIGN.md §5 bottom slot). The
// source of truth is web/package.json's `version`, injected at dev-server and
// build time as VITE_APP_VERSION via the `define` in vite.config.ts. The
// literal fallback only applies if that build define is somehow absent and must
// mirror package.json. Kept here (not hardcoded in the component) so the footer
// copy goes through i18n interpolation, not a literal in the view.
export const APP_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.0.10';

// Base URL for axios. In dev this is empty so Vite's proxy intercepts
// `/api/*` and forwards to :8080 (avoids CORS preflights). In a deployed
// build set VITE_API_BASE_URL to the absolute api origin.
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';
